import { IconCaution , IconCheckmarkCircle } from '../../assets/icons';
import styles from './ProfileHeader.module.css';

const ProfileHeader = ({ user, ddUser, emailVerified }) => {
    const profileData = {
        picture: user.picture,
        firstname: ddUser?.firstname,
        lastname: ddUser?.lastname,
        email: user.email,
        phone: ddUser?.phone,
    };

    return (
        <div className={styles.profileHeader}>
            <img
                className={styles.profileHeaderImg}
                src={profileData.picture}
                alt="Profile"
            />
            
            <div className={styles.profileHeaderInfo}>
                <h2 className={styles.profileHeaderName}>
                    {ddUser
                        ? profileData.firstname + " " + profileData.lastname
                        : profileData.name
                    }
                </h2>

                <h4 className={styles.profileHeaderEmail}>
                    <span style={{fontWeight: 400}}>e:</span> {profileData.email}
                    {emailVerified
                        ? <IconCheckmarkCircle style={{fill: "#10b981", marginLeft: ".25rem"}} />
                        : <IconCaution style={{fill: "#ff4433", marginLeft: ".25rem"}} />
                    }
                </h4>

                {profileData.phone && (
                    <h4 className={styles.profileHeaderPhone}>
                        <span style={{fontWeight: 400}}>p:</span> {profileData.phone}
                    </h4>
                )}
            </div>
        </div>
    )
}

export default ProfileHeader;